// extracted by mini-css-extract-plugin
module.exports = {"switch-container":"switch-btn_switch-container_1-tI4","btn":"switch-btn_btn_1H_YI","current":"switch-btn_current_32C96"};